<label class="container" style='margin: auto 32px;' >
    <input type="checkbox" (change)='change($event)'>
    <span class="checkmark" ></span>
    <ng-content></ng-content>
</label>
